import { render, staticRenderFns } from "./loginStatus.vue?vue&type=template&id=38bda8a6&scoped=true&"
import script from "./loginStatus.vue?vue&type=script&lang=ts&"
export * from "./loginStatus.vue?vue&type=script&lang=ts&"
import style0 from "./loginStatus.vue?vue&type=style&index=0&id=38bda8a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bda8a6",
  null
  
)

export default component.exports